<div class="thing" ref="target"><img class="preview" :src="imgSrc"><div class="subtitle"><div class="title">{{ thingId }}</div><div>Owner Name</div></div></div>